import React, { useEffect } from 'react';
import { withAppContext } from 'src/store/initAppContext';
import styled, { css, withTheme } from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { theme } from 'styled-tools';
import config from 'src/config/config';
import PlaceholderImage from 'src/components/Placeholder';

function AviatorIplPromo(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const isPK = brandId && (brandId == 35 || brandId == 36 || brandId == 37 || brandId == 49);
    const leagueType = isPK ? "PSL" : "IPL";

    const terms = [
        <>Valid From <strong>1 March to 31st May 2026.</strong></>,
        <>Must Launch <strong>Aviator game to claim free bets.</strong></>,
        <>Credited Free Bets Valid For <strong>48 hours only.</strong></>,
        <>Only Winnings From Free Bets Are Credited To Wallet.</>,
        <>Aviator Free Bets Are Distributed Randomly.</>,
        <>Limited To <strong>first 10,000 players per week.</strong></>,
        <>Cannot Be Combined With Other Promotions.</>,
        <>General Brand Terms & Conditions Apply.</>,
    ];

    return (
        <>
            <InformationWrapper>
                <HeaderSection>
                    <SmallTitle>Bet On {leagueType}, Get 3x Aviator Free Bets</SmallTitle>

                    <MainTitle>
                        WIN UP TO <strong>3x YOUR {leagueType} BET ON AVIATOR EVERY
                        <br />
                        SUNDAY!</strong> HIGHER YOUR BET, HIGHER YOUR FREE BET.
                    </MainTitle>

                    <RibbonWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorRibbon}`}
                            alt="Aviator Ribbon"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </RibbonWrapper>
                </HeaderSection>

                <SectionHeading>How To Claim</SectionHeading>

                <ClaimGrid>
                    <BigCard>
                        <StepNumber>1</StepNumber>

                        <CardTextWrap>
                            <h3>Bet On</h3>
                            <p>
                                Bet On <strong>{leagueType} Matches Via
                                <br />
                                BTI Sportsbook, Premium
                                <br />
                                Sportsbook, Saba
                                <br />
                                Sports, Or Exchange.</strong>
                            </p>
                        </CardTextWrap>
                    </BigCard>

                    <RightCards>
                        <SideCard $propsFreeBet>
                            <StepNumber>2</StepNumber>
                            <SideCardContent>
                                <TextArea>
                                    <h3>Free Bets</h3>
                                    <p>Receive <strong>Aviator Free Bets</strong> Every Sunday.</p>
                                </TextArea>
                            </SideCardContent>
                        </SideCard>

                        <SideCard $propsWinUpto>
                            <StepNumber>3</StepNumber>
                            <SideCardContent>
                                <TextArea>
                                    <h3>Win Up To 3x</h3>
                                    <p><strong>Win Up To 3x</strong> Your {leagueType} Bet Amount On Aviator Free Bets.</p>
                                </TextArea>
                            </SideCardContent>
                        </SideCard>

                        <SideCard $propsGHigherBet>
                            <StepNumber>4</StepNumber>
                            <SideCardContent>
                                <TextArea>
                                    <h3>Higher Your Bet</h3>
                                    <p>Higher Your Bet → <strong>Higher Your Aviator Free Bet</strong>.</p>
                                </TextArea>
                            </SideCardContent>
                        </SideCard>
                    </RightCards>
                </ClaimGrid>

                <TermsHeading>Terms & Conditions</TermsHeading>

                <TermsList>
                    {terms.map((term, index) => (
                        <TermItem key={index}>
                            <span>✦</span>
                            <p>{term}</p>
                        </TermItem>
                    ))}
                </TermsList>
            </InformationWrapper>

        </>
    );
}

export default withTheme(withAppContext(AviatorIplPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsInnerBg")});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    color: #fff;
    text-transform: capitalize;

    strong {
        color: #ffffff;
        font-family: 'Inter-Bold';
    }
`;

const HeaderSection = styled.div`
    width: 100%;
    /* max-width: 1100px; */
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1.2rem 1rem 0;
    padding-bottom: 15%;
    position: relative;
`;

const SmallTitle = styled.p`
    margin: 0;
    color: #ff2a2a;
    font-size: 18px;
    font-family: 'Inter-Bold';
    line-height: 1.2;
`;

const MainTitle = styled.h1`
    margin: 18px 0 0;
    color: #f3f3f3;
    font-size: 22px;
    line-height: 1.45;
    font-family: 'Inter';
    letter-spacing: 0.3px;
    text-transform: uppercase;
    font-weight: 100;
`;

const RibbonWrapper = styled.div`
    width: 100%;
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 90px;
    left: 0;
    right: 0;

    img {
        width: 100%;
        max-width: 100%;
        display: block;
    }
`;

const SectionHeading = styled.h2`
    margin: 2rem 0 1.8rem;
    color: #ff1d1d;
    font-size: 20px;
    font-family: 'Inter-Bold';
    text-align: center;
`;

const ClaimGrid = styled.div`
    width: 100%;
    max-width: 900px;
    display: grid;
    grid-template-columns: 1fr 1.9fr;
    gap: 16px;
    align-items: stretch;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        padding: 0 1rem;
    }
`;

const GlassCard = `
    position: relative;
    border-radius: 15px;
    border: 1.5px solid rgb(148 148 148);
    backdrop-filter: blur(7.5px);
    overflow: hidden;
`;

const BigCard = styled.div`
    ${GlassCard};
    min-height: 328px;
    padding: 22px 22px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsBetOneBg")});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

const RightCards = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

const SideCard = styled.div<{ $propsFreeBet?: boolean, $propsWinUpto?: boolean, $propsGHigherBet?: boolean }>`
    ${GlassCard};
    min-height: 96px;
    padding: 18px 34% 18px 14px;
    display: flex;
    align-items: center;
    
    ${(props) => props.$propsFreeBet && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsFreeBetsBg")});
    `}

    ${(props) => props.$propsWinUpto && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsWinUptoBg")});
    `}

    ${(props) => props.$propsGHigherBet && css`
        background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorFreeBetsWthIPLBetsHigherYourBetBg")});
    `}

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;

const StepNumber = styled.div`
    position: absolute;
    top: 18px;
    left: 18px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    z-index: 2;
`;

const CardTextWrap = styled.div`
    padding-left: 58px;
    padding-top: 4px;

    h3 {
        margin: 0 0 8px;
        font-size: 24px;
        font-family: 'Inter-Bold';
        color: #fff;
    }

    p {
        margin: 0;
        color: #f5f5f5;
        font-size: 16px;
        line-height: 1.45;
        font-weight: 600;
    }
`;

const SideCardContent = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding-left: 58px;
`;

const TextArea = styled.div`
    h3 {
        margin: 0 0 6px;
        font-size: 18px;
        font-family: 'Inter-Bold';
        color: #fff;
    }

    p {
        margin: 0;
        color: #efefef;
        font-size: 16px;
        line-height: 1.35;
        font-weight: 500;
    }
`;

const TermsHeading = styled.h2`
    margin: 3rem 0 1.5rem;
    color: #ff1d1d;
    font-size: 20px;
    font-family: 'Inter-Bold';
    text-align: center;
`;

const TermsList = styled.ul`
    width: 100%;
    max-width: 535px;
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const TermItem = styled.li`
    width: 100%;
    background: #3A3A3A;
    min-height: 36px;
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 8px 30px;
    box-sizing: border-box;

    span {
        color: #fff;
        font-size: 14px;
        flex: 0 0 16px;
    }

    p {
        margin: 0;
        color: #fff;
        font-size: 16px;
        line-height: 1.35;
        font-weight: 500;
    }
`;